<template>
    <div id="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br/>
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            {{ userStore.user.ssn }}
            <br />
            <br />
            {{ creditBureau.address_name }}
            <br />
            {{ creditBureau.street_address }}
            <br />
            {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
            <br />
            <br />
            Date: {{ date }}
        </p>
        <div class="page">
            <p>
                <strong>ATTN:</strong> {{ creditBureau.name }} Legal Department,
                <br />
            </p>
            <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                <p>
                    <strong> RE: {{ creditor.reference_number ? creditor.reference_number : creditor.account_number }} </strong>
                    <br />
                    I am disputing the account stated above. Previously, I disputed this account information as being inaccurate, and you responded by stating you were able to verify this debt. But how is that possible? Under the laws of the FDCPA, I have contacted the collection agency <strong>{{ creditor.furnisher_name }}</strong> myself, and they have failed to verify that this is indeed my debt.
                </p>
            </template>
            <p class="letter-content">
                <br />
                <br />
                I enclosed copies of my requests to the collection agency, asking them to
                validate the debt, as well as the receipts showing I sent this letter by
                certified signature request. I was given no evidence of my obligation to pay
                this debt to this collection agency.
                <br />
                <br />
                The Fair Credit Reporting act requires you to verify the validity of this within
                30 days. If the validity cannot be verified, you are obligated by law to remove
                it from my credit file. I urge you to remove this account before I am forced to
                take legal action.
                <br />
                <br />
                In the event that you cannot verify the item pursuant to FCRA, and you continue
                to report it on my credit, I will find it necessary to sue you for actual
                damages and declaratory relief. According to FCRA regulations, I may sue you in
                any qualified state or federal court, including small claims court in my area.
                <br />
                <br />
                I look forward to a swift and amicable resolution to this matter.

            </p>
            <p style="page-break-after: always;">
                Thank you for your time,
                <br />
                <br />
                {{ userStore.user.firstname }} {{ userStore.user.lastname }}
                <br />
                {{ userStore.user.address }}
                <br />
                {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
                <br />
                {{ userStore.user.ssn }}
            </p>
        </div>
        <h1 style="margin: 5rem 5rem;">Personal Information</h1>
        <div class="row">
            <p>
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>